module.exports = __webpack_public_path__ + "static/img/guide-betting-history.56001ee.jpg";